import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export interface PacPlan {
  RmiCreatedBy: string,
  RmiCreatedDate:  string,
  RmiDescription:  string,
  RmiDischargeDate: null | string
  RmiDischargeSummary:  string,
  RmiMedReconciliation:  string,
  RmiModifiedBy:  string,
  RmiModifiedDate:  string,
  RmiMostRecentHospDate: string,
  RmiNoteBy:  string,
  RmiNoteDate:  string,
  RmiPlanId: number
  RmiPlanNo:  string,
  RmiStatusId: number
}

export interface PacNotesResponse {
  [index: number]: {
    RmiCreatedBy: string,
    RmiCreatedDate: string,
    RmiDescription: string,
    RmiModifiedBy: string,
    RmiModifiedDate: string,
    RmiNoteBy: string,
    RmiNoteDate: string,
    RmiNoteId: number,
    RmiReadBy: string,
    RmiReadDate: string,
    RmiReadFlag: string
  }
}

export interface PacNote {
  RmiCreatedBy: string,
  RmiCreatedDate: string,
  RmiDescription: string,
  RmiModifiedBy: string,
  RmiModifiedDate: string,
  RmiNoteBy: string,
  RmiNoteDate: string,
  RmiNoteId: number,
  RmiReadBy: string,
  RmiReadDate: string,
  RmiReadFlag: string
}

export const getNotes = (userId: string, membMpiNo: string, companyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_PAC_NOTES_REQUEST });

  return api.eligibility.pac.getNotes(userId, membMpiNo, companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_PAC_NOTES_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PAC_NOTES_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getInfoForCarePlanPage = (userId: string, pacType: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_PAC_INFO_FOR_CARE_PLAN_PAGE_REQUEST });

  return api.eligibility.pac.getInfoForCarePlanPage(userId, pacType)
    .then((res: any) => {

      dispatch({
        type: types.GET_PAC_INFO_FOR_CARE_PLAN_PAGE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PAC_INFO_FOR_CARE_PLAN_PAGE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getUnreadTypeCount = (userId: string, pacType: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_UNREAD_PAC_TYPE_COUNT_REQUEST });

  return api.eligibility.pac.getUnreadTypeCount(userId, pacType)
    .then((res: any) => {

      dispatch({
        type: types.GET_UNREAD_PAC_TYPE_COUNT_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_UNREAD_PAC_TYPE_COUNT_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getNoteLogs = (noteId: number) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_PAC_NOTE_LOGS_REQUEST });

  return api.eligibility.pac.getNoteLogs(noteId)
    .then((res: any) => {

      dispatch({
        type: types.GET_PAC_NOTE_LOGS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PAC_NOTE_LOGS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getStatus = () => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_PAC_STATUS_REQUEST });

  return api.eligibility.pac.getStatus()
    .then((res: any) => {

      dispatch({
        type: types.GET_PAC_STATUS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PAC_STATUS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getPlans = (userId: string, membMpiNo: string, companyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_PAC_PLANS_REQUEST });

  return api.eligibility.pac.getPlans(userId, membMpiNo, companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_PAC_PLANS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PAC_PLANS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getDetailPlan = (planId: number, userId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_PAC_DETAIL_PLAN_REQUEST });

  return api.eligibility.pac.getDetailPlan(planId, userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_PAC_DETAIL_PLAN_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PAC_DETAIL_PLAN_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getMedDetail = (planId: number) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_PAC_MED_DETAIL_REQUEST });

  return api.eligibility.pac.getMedDetail(planId)
    .then((res: any) => {

      dispatch({
        type: types.GET_PAC_MED_DETAIL_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PAC_MED_DETAIL_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getPlanLogs = (planId: number) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_PAC_PLAN_LOGS_REQUEST });

  return api.eligibility.pac.getPlanLogs(planId)
    .then((res: any) => {

      dispatch({
        type: types.GET_PAC_PLAN_LOGS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_PAC_PLAN_LOGS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const updateReadInfo = (passedUserId: string, passedPacUid: string, passedPacType: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.eligibilityPAC.isUpdating) { return Promise.reject(); }

  dispatch({ type: types.UPDATE_PAC_READ_INFO_REQUEST });

  const pacObj = {
    UserId: passedUserId,
    PacUid: passedPacUid,
    PacType: passedPacType
  };

  return api.eligibility.pac.updateReadInfo(pacObj)
    .then((res: any) => {

      dispatch({
        type: types.UPDATE_PAC_READ_INFO_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.UPDATE_PAC_READ_INFO_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const saveNote = (note: Object) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.eligibilityPAC.isSavingNote) { return Promise.reject(); }

  dispatch({ type: types.SAVE_PAC_NOTE_REQUEST });

  return api.eligibility.pac.saveNote(note)
    .then((res: any) => {

      dispatch({
        type: types.SAVE_PAC_NOTE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.SAVE_PAC_NOTE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const savePlan = (plan: Object) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.eligibilityPAC.isSavingPlan) { return Promise.reject(); }

  dispatch({ type: types.SAVE_PAC_PLAN_REQUEST });

  return api.eligibility.pac.savePlan(plan)
    .then((res: any) => {

      dispatch({
        type: types.SAVE_PAC_PLAN_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.SAVE_PAC_PLAN_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};